import React, { useMemo } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import styled from 'styled-components';
import SnpBookListItem from '../SnpBookItem/SnpBookItem';

const RESPONSIVE = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const Wrapper = styled.div`
  .snp-books-news-carousel {
    .react-multiple-carousel__arrow {
      background: transparent;
      border: 1px solid #d9d9d9;

      ::before {
        color: black;
      }
    }
  }
`;

function SnpBookList({ books = [] }) {
  const slideBooks = useMemo(
    () =>
      books.reduce((acc, curr, index) => {
        if (index % 2 === 0) {
          acc.push([curr]);
          return acc;
        }
        const newBookItems = [...acc.pop(), curr];
        acc.push(newBookItems);
        return acc;
      }, []),
    [books]
  );

  if (!books.length) {
    return (
      <div className="book-news-list__no-data">
        <i>Không tìm thấy tài liệu nào</i>
      </div>
    );
  }

  return (
    <Wrapper>
      <Carousel
        arrows
        responsive={RESPONSIVE}
        keyBoardControl
        containerClass="snp-books-news-carousel"
        itemClass="px-[8px]"
      >
        {slideBooks.map(
          (bookItems) => (
            <div key={bookItems}>
              {bookItems?.map((book) => (
                <SnpBookListItem
                  key={book.RecordID}
                  book={book}
                  className="mb-3"
                />
              ))}
            </div>
          )
          // eslint-disable-next-line function-paren-newline
        )}
      </Carousel>
      <div className="text-center mb-4">
        <a
          href="/module/tai-lieu-so-theo-loai?type=book"
          className="btn btn-outline-danger rounded-pill fs-sm px-4"
          target="_blank"
        >
          Xem tất cả
        </a>
      </div>
    </Wrapper>
  );
}

export default SnpBookList;
